exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#aboutComp {\n  display: block;\n}\nh2{\n  text-align: center;\n  font-family: 'PT Sans', sans-serif;\n}\np{\n  color: #788188;\n  margin: 0 0 19.44444px;\n  font-family: 'PT Sans', sans-serif;\n}\n.container{\n  text-align: center;\n  width: 100%;\n  -webkit-box-flex: 0;\n      -ms-flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'> ];\n          flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'> ]\n}\n#signature{\n  width: 200px;\n  height: 50px;\n  padding-bottom: 2%;\n}\n\nimg {\n  width: 80%;\n  height: 80%;\n}\n@media only screen and (max-width: 749px){p{font-size:0.9375em}}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/page_components/about/about.component.css
// module id = 374
// module chunks = 1